import { defineMessages } from 'react-intl';

const messages = defineMessages({
  RelationGlobalActionsTooltip:
    'Select one or more relations to execute a global action on these relations.',
  GlobalActions: 'Global actions',
  Relation: 'Relation',
  Compliance: 'Compliance',
  FullyCompliant: 'Fully compliant',
  NoComplianciesFound: 'No compliancies found',
  ResetFilters: 'Reset filters',
  CountRelationsSelected: 'Selected {count} / {total} relations',
  SendEmail: 'Send email',
  SendEmailQueued:
    'Emails for the selected relations are being sent. Click here to view its progress.',
  EmailSent: 'Email sent',
  Actions: 'Actions',
  MarkAsInapplicable: 'Mark as inapplicable',
  MarkAsApplicable: 'Mark as applicable',
  ChangesSaved: 'Changes saved',
  ExportToExcel: 'Export to Excel',
  ComplianceType: 'Compliance type',
  ToggleComplianceTypeApplicable: 'Toggle compliance type applicable',
  ComplianceMarkedAsInapplicable: 'The compliancies were marked as inapplicable',
  Loading: 'Loading',
  NotApplicable: 'Not applicable',
  ComplianciesWillBeCalculatedInTheBackground:
    'The compliancies will be calculated in the background.',
  AMLEndScore: 'AML end score',
  ExportToExcelStarted: 'Export to Excel started',
  NewRegistration: 'New registration',
  NewRegistrationsQueued: 'New registrations will be created shortly.',
  AddOrRemoveLabels: 'Add or remove labels',
  LabelsAddedQueued: 'The label(s) will be added to the selected relations shortly.',
  LabelsRemovedQueued: 'The label(s) will be removed from the selected relations shortly.',
});

export default messages;
